<template>
  <section class="model-account-page">
    <h2>我的模型账号</h2>
    <p>拓扑生成、诊断和演化使用你在 ai-token 中的个人 Key，用量由账号中心记录。</p>
    <p v-if="notice" role="status">{{ notice }}</p>
    <p v-if="error" class="error" role="alert">{{ error }}</p>
    <form @submit.prevent="save">
      <label>模型 Key<select v-model="selection" :disabled="busy">
        <option value="">自动选择最新可用 Key</option>
        <option v-for="entry in keys" :key="entry.id" :value="entry.id" :disabled="!entry.available">{{ entry.name }} · 尾号 {{ entry.suffix }}{{ entry.available ? '' : ' · 不可用' }}</option>
      </select></label>
      <p v-if="effective" class="hint">当前使用：{{ effective.name }} · 尾号 {{ effective.suffix }}{{ effective.available ? '' : ' · 不可用，请更换' }}</p>
      <p v-else class="hint">当前没有可用 Key。可以继续管理拓扑和库，调用模型前请在账号中心检查 Key、有效期和额度。</p>
      <button :disabled="busy">{{ busy ? '处理中…' : '保存选择' }}</button>
      <button type="button" :disabled="busy" @click="refresh">刷新 Key 状态</button>
      <a href="/ai-token/" target="_blank" rel="noopener">打开账号中心</a>
    </form>
  </section>
</template>
<script>
import { apiJSON, jsonBody } from '../api/http'
export default {
  name: 'ModelAccountPanel',
  data: () => ({ keys: [], selection: '', effectiveId: null, busy: false, error: '', notice: '' }),
  computed: { effective() { return this.keys.find(entry => entry.id === this.effectiveId) } },
  mounted() { this.refresh() },
  methods: {
    async refresh() {
      this.busy = true; this.error = ''
      try { const data = await apiJSON('/api/model-account'); this.keys = data.keys; this.selection = data.selected_key_id || ''; this.effectiveId = data.effective_key_id; return true }
      catch (error) { this.error = error.message; return false }
      finally { this.busy = false }
    },
    async save() {
      this.busy = true; this.error = ''; this.notice = ''
      try { await apiJSON('/api/model-account', jsonBody('PUT', { api_key_id: this.selection || null })); if (await this.refresh()) this.notice = '模型 Key 选择已保存，将用于之后提交的请求。' }
      catch (error) { this.error = error.message }
      finally { this.busy = false }
    }
  }
}
</script>
<style scoped>
.model-account-page { flex: 1; overflow: auto; background: #f4f7fb; padding: 28px; color: #21324b; }
form { max-width: 720px; background: white; padding: 24px; border: 1px solid #dfe7ef; border-radius: 10px; }
label { display: flex; flex-direction: column; gap: 12px; }
select,button { font: inherit; padding: 10px; border: 1px solid #cbd5e1; border-radius: 6px; }
button { background: white; margin: 12px 12px 0 0; cursor: pointer; }
.hint { color: #64748b; line-height: 1.6; }.error { color: #b42318; }
a { display: inline-block; margin-top: 12px; color: #2563eb; }
</style>
